<template>
    <page-padding>
     
      <spinner v-if="showLoader && !hasNews" class="spinner-custom" />
      <div v-if="!hasNews">{{$t('language.no_news')}}</div>
      <div v-if="hasNews">


        <div>
          <div class="featured_container" v-for='(item, index) in sliceArray(news["0featured"],3)' v-bind:key="item.id" @click="viewNewsItem(item.id)">
              <featured-news-item class="featured-btn" :index="index" type="news" :item="item" :title="item.title" :text="createIntroText(item.content)" :image_src="item.f_img" :readMore="true"/>
          </div>
        </div>
        
        <button-more title="language.view_more_news" to="/group/0/globalnews/init"/>
      </div>
    </page-padding>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import Spinner from '../../components/Spinner';
import FeaturedNewsItem from './FeaturedNewsItem';
import ButtonMore from '../../components/buttons/ButtonMore';
import { helper } from '../../services/Helper.js';

export default {
  name: 'list-news-featured',
  props:{
  },
  data:function(){
    return {
      hasNews:true,
      showLoader:true,
    }
  },
  components:{
    PagePadding,
    Spinner,
    FeaturedNewsItem,
    ButtonMore,
  },
  methods:{
    sliceArray(arr,count){
      if(arr){
        return arr.slice(0,count)
      }else{
        return [];
      }
    },
    viewNewsItem(id){
      this.$router.push({path:"/news_item/"+id})
    },
    createIntroText(txt){
         return helper.getExcerpt(txt);
    },
    loadNews(){
        this.showLoader=true;
        
        this.$store.dispatch('get_news',{id:0,feed:undefined}).then(()=>{
          this.hasNews = this.news["0featured"] ? this.news["0featured"].length : false;
          this.showLoader=false;
        })
      }
  },
  computed:{
    ...mapState([
       'news',
       ]),
  },

  mounted:function(){
    this.loadNews();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.featured_container{
  padding:25px 0px;
  border-bottom: 1px solid #DDDDDD;
}
.featured_container:first-child{
  border-top: 1px solid #DDDDDD;
  margin-top:15px;
}
.featured_container:last-child{
  margin-bottom:15px;
}

.spinner-custom{
  margin:10px 0;
}
</style>

